(function($) { "use strict";

	$(document).ready(function(){"use strict";
		
		var progressPath = document.querySelector('.progress-wrap path');
		var pathLength = progressPath.getTotalLength();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
		progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
		progressPath.style.strokeDashoffset = pathLength;
		progressPath.getBoundingClientRect();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
		var updateProgress = function () {
			var scroll = $(window).scrollTop();
			var height = $(document).height() - $(window).height();
			var progress = pathLength - (scroll * pathLength / height);
			progressPath.style.strokeDashoffset = progress;
		}
		updateProgress();
		$(window).scroll(updateProgress);	
		var offset = 50;
		var duration = 550;
		jQuery(window).on('scroll', function() {
			if (jQuery(this).scrollTop() > offset) {
				jQuery('.progress-wrap').addClass('active-progress');
			} else {
				jQuery('.progress-wrap').removeClass('active-progress');
			}
		});				
		jQuery('.progress-wrap').on('click', function(event) {
			event.preventDefault();
			jQuery('html, body').animate({scrollTop: 0}, duration);
			return false;
		})
		
		
	});
	
})(jQuery);
$(document).ready(function () {
  initHeaderSticky()
});
$(window).resize(function() {
  initHeaderSticky()
});
$(window).scroll(function() {
  initHeaderSticky()
});
function initHeaderSticky() {
  if (jQuery(document).height() > jQuery(window).height()) {
    if (jQuery(this).scrollTop() > 400) {
      jQuery('.site-header').addClass("fixed");
    } else {
      jQuery('.site-header').removeClass("fixed");
    }
  }
}
$(document).ready(function() {

    // address page
    $('.edit-spacer input[type="hidden"][name="_method"][value="put"]').remove();
  
  var contentDiv = $('#WebPixelsManagerSandboxContainer');
  $('footer').after(contentDiv);
  countDownIni('.flip-countdown,.js-flip-countdown'); 
 /********* On scroll heder Sticky *********/
   var prevScrollpos = window.pageYOffset;
  // window.onscroll = function () {
  //   var currentScrollPos = window.pageYOffset;
  //   if (prevScrollpos > currentScrollPos) {
  //     document.getElementById("header-sticky").style.top = "0";
  //   } else {
  //     document.getElementById("header-sticky").style.top = "-200px";
  //   }
  //   prevScrollpos = currentScrollPos;
  // } 
    /********* Mobile Menu ********/  
    $('.mobile-menu-button').on('click',function(e){
        e.preventDefault();
        setTimeout(function(){
            $('body').addClass('no-scroll active-menu');
            $(".mobile-menu-wrapper").toggleClass("active-menu");
            $('.overlay').addClass('menu-overlay');
        }, 50);
    }); 
    $('body').on('click','.overlay.menu-overlay, .menu-close-icon svg', function(e){
        e.preventDefault(); 
        $('body').removeClass('no-scroll active-menu');
        $(".mobile-menu-wrapper").removeClass("active-menu");
        $('.overlay').removeClass('menu-overlay');
    });
    /********* Mobile Filter Popup ********/
    $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no-scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    });  
    var $this = $('.collection');
    if ($this.hasClass("collection-leftfilter")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
    var $this = $('.collection');
    if ($this.hasClass("collection-rightfilter")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
   /********* category product ********/
    $(".list-view").click(function () {
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");

      $(".grid-product .row").removeClass("flex-slider");
      $(".grid-product .row").addClass("product-grid-view");

      jQuery('.product-grid-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-image-wrapper');
        jQuery(this).find('.product-card-image').insertAfter(prod_img);
        var prod_lbl = jQuery(this).find('.product-top-content');
        jQuery(this).find('.top-lable').prependTo(prod_lbl);
        var prod_count = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-image-bottom .simple-countdown').appendTo(prod_count);
        var prod_img = jQuery(this).find('.product-bottom-content');
        jQuery(this).find('.reviews-stars-wrap').prependTo(prod_img);
         var prod_img = jQuery(this).find('.reviews-stars-wrap');
        jQuery(this).find('.price').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.price');
        jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.wish-lbl-wrp');
        jQuery(this).find('.cart-variable').insertAfter(prod_img);
        var prod_desc = jQuery(this).find('.product-content .product-bottom-content');
        jQuery(this).find('.product-image-bottom .cart-btn-content').appendTo(prod_desc);
      });
    });
    $(".grid-view").click(function () {
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");

      $(".grid-product .row").addClass("flex-slider");
      $(".grid-product .row").removeClass("product-grid-view");

      jQuery('.flex-slider > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-image-wrapper');
        jQuery(this).find('.product-card-image').prependTo(prod_img);
        var prod_count = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.product-top-content .simple-countdown').appendTo(prod_count);
        var new_lbl = jQuery(this).find('.product-image-wrapper');
        jQuery(this).find('.wish-lbl-wrp').appendTo(new_lbl);
        var prod_lbl = jQuery(this).find('.wish-lbl-wrp');
        jQuery(this).find('.wish-lbl-wrp .product-lbl').insertBefore(prod_lbl);
        var prod_wish = jQuery(this).find('.wish-lbl-wrp');
        jQuery(this).find('.reviews-stars-wrap .wishlist-btn').appendTo(prod_wish);
        var prod_desc = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.product-content .product-bottom-content .cart-btn-content').prependTo(prod_desc);
      });
    });
      /*********  Header Search Popup  ********/
    $(".search-header a").click(function () {
      $(".search-popup").toggleClass("active");
      $("body").toggleClass("no-scroll");
    });
    $(".close-search").click(function () {
      $(".search-popup").removeClass("active");
      $("body").removeClass("no-scroll");
    });
     /********* Cart Popup ********/

    if ($('body').hasClass('cart')) {
        // Disable click on the cart-header div
        $('.cart-header').on('click', function(event) {
            event.preventDefault();
            return false;
        });
    }else{

    $('.cart-header').on('click', function (e) {
    e.preventDefault();
    setTimeout(function () {
      $('body').addClass('no-scroll cartOpen');
      $('.overlay').addClass('cart_overlay');
    }, 50);
  });
  }
  $('body').on('click', '.overlay.cart_overlay, .closecart', function (e) {
    e.preventDefault();
    $('.overlay').removeClass('cart_overlay');
    $('body').removeClass('no-scroll cartOpen');
    $('.coupon-popup').removeClass('active');
    $('.gift-popup').removeClass('active');
  });

   /*********coupon popup ********/
  $(document).on('click', '.coupan-icon', function () {
    $(".coupon-popup").toggleClass("active");
  });
  $(document).on('click', '.gift-icon', function () {
    $(".coupon-popup").removeClass("active");
  });
  $(document).on('click', '.close-coupon', function () {
    $(".coupon-popup").removeClass("active");
  });
  
  // coupan code
    $('body').on('keyup','.discount-coupon', function() {
     var apply_href = $('.apply').attr("href").split('discount=')[0];
     var val = $(this).val();
      $('.apply').attr("href",apply_href+'discount='+val);
       $('.apply').trigger('click');
    });

  /*********gift popup ********/
  $(document).on('click', '.gift-icon', function () {
    $(".gift-popup").toggleClass("active");
  });
  $(document).on('click', '.coupan-icon', function () {
    $(".gift-popup ").removeClass("active");
  });
  $(document).on('click', '.close-gift', function () {
    $(".gift-popup").removeClass("active");
  });

    /*********  size Popup  ********/ 
      $(".size-btn").click(function() { 
        $(".size-popup").toggleClass("active"); 
        $("body").toggleClass("no-scroll");
    });
    $(".close-search").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
    $(".close-btn").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
        /******* Subscribe popup Js *******/
    if ($('.subscribe-popup').length > 0) {
    $('body').addClass('no-scroll');
  }
    $('.close-sub-btn').click(function () {
      $('.subscribe-popup').slideUp(); 
      $(".subscribe-overlay").removeClass("open");
      $('body').removeClass('no-scroll');
    });    
    /*********  Multi-level accordion nav  ********/ 
    $('.acnav-label').click(function () {
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav-list');
        if (parent.hasClass('is-open')) {
            list.slideUp('fast');
            parent.removeClass('is-open');
        }
        else {
            list.slideDown('fast');
            parent.addClass('is-open');
        }
    });  
  $('.acnav-label1').click(function (event) {
  event.preventDefault();
  if(jQuery( window ).width() < 768) {
    var label = $(this);
    var parent = label.parent('.has-children1');
    var list = label.siblings('.acnav-list1');
    if (parent.hasClass('is-open')) {
        list.slideUp('fast');
        parent.removeClass('is-open');
    }
    else {
        list.slideDown('fast');
        parent.addClass('is-open');
    }
  }
});
    /****  TAB Js ****/
    $("ul.tabs li").click(function () {
      var $this = $(this);
      var $theTab = $(this).attr("data-tab");
      if ($this.hasClass("active")) {
      } else {
        $this
          .closest(".tabs-wrapper")
          .find("ul.tabs li, .tabs-container .tab-content")
          .removeClass("active");
        $(
          '.tabs-container .tab-content[id="' +
            $theTab +
            '"], ul.tabs li[data-tab="' +
            $theTab +
            "]"
        ).addClass("active");
      }
      $(this).addClass("active");
    });
  // load-more button scroll
  function loadMoreProducts(nextUrl, totalPages) {
  var $this = $('.js-load-more'),
      currentPage = parseInt($('[data-this-page]').val()),
      datacollurl = $('[data-coll-url]').val();
  
  $this.attr('disabled', true);
  $this.addClass('hide');
  $this.siblings('[loader]').removeClass('hide');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('[data-next-link]').val(datacollurl + "?page="+next_coll);
      $('[data-this-page]').val(current_page_new);
      
      // Replace the following line with the appropriate selector for your HTML structure
      $('.flex-slider, .product-grid-view').append($(responseHTML).find('.flex-slider, .product-grid-view').html());
      
      countDownIni('.flip-countdown,.js-flip-countdown'); 

      jQuery('.product-grid-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-image-wrapper');
        jQuery(this).find('.product-card-image').insertAfter(prod_img);
        var prod_lbl = jQuery(this).find('.product-top-content');
        jQuery(this).find('.top-lable').prependTo(prod_lbl);
        var prod_count = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-image-bottom .simple-countdown').appendTo(prod_count);
        var prod_img = jQuery(this).find('.product-bottom-content');
        jQuery(this).find('.reviews-stars-wrap').prependTo(prod_img);
         var prod_img = jQuery(this).find('.reviews-stars-wrap');
        jQuery(this).find('.price').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.price');
        jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.wish-lbl-wrp');
        jQuery(this).find('.cart-variable').insertAfter(prod_img);
        var prod_desc = jQuery(this).find('.product-content .product-bottom-content');
        jQuery(this).find('.product-image-bottom .cart-btn-content').appendTo(prod_desc);
      });
      
    },
    complete: function() {
      if (current_page_new < totalPages) {
        $this.attr('disabled', false);
        $this.removeClass('hide');
        $this.siblings('[loader]').addClass('hide');
      } else{
         $this.parents('.load-more_wrap').addClass('hide');
      }
    } 
  });
}    

  $('.js-load-more').on('click', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

  $('.product-grid-view').on('click', '.js-load-more', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

// product slider zoom
    $('.pdp-slider-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });

// sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products_add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products_add-cart-sticky').addClass('show-btn');
        }
    });
    }

   $(".stickyOpt.nice-select").on('click', function(){
		$(this).toggleClass('open');
    });
    $(".stickyOpt .vrOpt").on('click', function(e){
        var sectionId = $('.pdp-page-main-sec').attr('data-section-id');
		var number = $(this).data('no');
        $(".stickyOpt .selectedOpt").html($(this).html());
      	$(this).toggleClass('open');
      	this.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
        var stOpt = this.productvariants[number],
            o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
        $('.stickCtImg').attr('src', stOpt.featured_image.src+'&width=100');
        if($('select.single-option-selector').length){
        } else {
            if(o2 != null){var stOpt2 = o2.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt2+"']").prop("checked",true)}
            if(o3 != null){var stOpt3 = o3.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt3+"']").prop("checked",true)}
            if(o1 != null){var stOpt1 = o1.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt1+"']").trigger('click')}
        }
    });
  
      $(".stickyQty .quantity__button").on("click", function(){
      var qtyField = $('.mianQty'),oldValue = $(qtyField).val(),newVal = 1;
      if ($(this).is(".quantity-increment")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).val(newVal).trigger('change');
    });
    $('.mianQty').on("change", function(){
      $('#stquantity').val($(this).val());
    });
// end sticky

  
  // quickview
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });
  
  $('body').on('click', '.quickview-btn, .show-qv', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      var swiper = new Swiper(".qv_slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        speed: 800,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

    });
    $('.quickview-popup').show();
  });

$('body').on('click', '.quickview_popup_data .size-select .button', function() {
   var data_val = $(this).children('input:checked').val();
   $(this).parents('.radio-buttons').find('.option-label').text(data_val);
  
  var selectedValues = [];

  // Collect selected option values
  $('.quickview_popup_data .size-select .button input:checked').each(function() {
    var selectedValue = $(this).val();
    
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });
var joinedValues = selectedValues.join(' / ');

  $('.variant-qv').each(function() {
    var variant_title = $(this).data('title');
    var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
    var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
    var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
    var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');

    // Check if variant_title exists in the selectedValues array
    if(variant_title === joinedValues){
      
      var variantImageIndex = $('.quickview-img-slider .quickview-card-image img[data-img="'+variant_img+'"]').parents('.qv-pro-slider-img').index();
      new Swiper('.quickview-img-slider').slideTo(variantImageIndex);

      $('.qv-price').find('.price-item--regular').text(variant_price);

      if (qv_btn === true) {
        $('.quickview_popup_data .product-form__submit').find('span').text('Add To Cart');
        $('.quickview_popup_data .product-form__submit').removeAttr('disabled');
      } else {
        $('.quickview_popup_data .product-form__submit').find('span').text('Sold out');
        $('.quickview_popup_data .product-form__submit').attr('disabled', 'disabled');
         $('.quickview_popup_data .product-form__submit > svg').remove();
      }

      $('input[name="id"]').val(variant_id);
    }
  });
});
  // end quickview

          // currency-nice-select
$('body').on('click', '.country-name .nice-select', function (e) {
  e.stopPropagation(); // Stop the event from propagating to the body
  $(this).toggleClass('open');
});
$('body').on('click', function (e) {
  $('.country-name .nice-select').removeClass('open');
});

// currency
function currencyFormSubmit(event) {
  event.target.form.submit();
}

document.querySelectorAll('.country-name .nice-select .list li').forEach(function (currencyItem) {
  currencyItem.addEventListener('click', function () {
    // Trigger change event on the associated select element
    var selectElement = this.closest('.country-name').querySelector('select');
    if (selectElement) {
      // Set the selected option based on the data-currency attribute of the clicked li
      selectElement.value = this.dataset.currency;
      
      // Trigger change event
      var event = new Event('change', { bubbles: true });
      selectElement.dispatchEvent(event);

      // Submit the form
      currencyFormSubmit({ target: selectElement });
    }
  });
});

  // custom review
  setTimeout(function() {
    $('.pdp-right-column .jdgm-prev-badge').on('click', function() {
    $('.pdp-tab-right').find("li.active").removeClass('active');
    $('.pdp-tab-right').find("li[data-tab='pdp-tab-2']").addClass('active');
    $('.tab-content.active').removeClass('active');
    $(".tab-content[id='pdp-tab-2']").addClass('active'); 
    });
  }, 1000); 

  
   // notify me
  
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });
});  
/********* Wrapper top space End********/
/*** annouce slider */
 let SwiperTop = new Swiper('.swiper--top', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    disableOnInteraction: true
  });
  /*** home banner slider */
  var swiper = new Swiper(".home-banner-slider", {
    // effect: "fade",
    speed: 800,
    // autoplay:true,
    loop:true,
    navigation: {
      nextEl: ".home-arrow-next",
      prevEl: ".home-arrow-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
    },
  });
  /***product slider */
  var swiper = new Swiper(".product-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    speed: 800,
    navigation: {
      nextEl: ".product-slide.swiper-button-next",
      prevEl: ".product-slide.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
        576: {
        slidesPerView: 2,
      },
     0: {
        slidesPerView: 1,
      },
    },
  });
  /***** bestseller slider *****/
  var swiper = new Swiper(".bestseller-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    speed: 800,
    navigation: {
      nextEl: ".bestseller-slide.swiper-button-next",
      prevEl: ".bestseller-slide.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
         576: {
        slidesPerView: 2,
      },
     0: {
        slidesPerView: 1,
      },
    },
  });
  /***** bestseller slider *****/
  var swiper = new Swiper(".testimonials-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".testi-slide.swiper-button-next",
      prevEl: ".testi-slide.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /***** blog slider *****/
   var swiper = new Swiper(".blog-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    speed: 800,
    navigation: {
      nextEl: ".blog-slide.swiper-button-next",
      prevEl: ".blog-slide.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
 /** service slider **/
   var swiper = new Swiper(".service-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
     slidesPerView: 3,
    navigation: {
      nextEl: ".service-arrow-next.swiper-button-next",
      prevEl: ".service-arrow-prev.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      100: {
        slidesPerView: 1,
      },
    },
  });
  /***** partnert logo slider *****/
  var swiper = new Swiper(".partner-logo-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    speed: 800,
    navigation: {
      nextEl: ".brand-slider.swiper-button-next",
      prevEl: ".brand-slider.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
        spaceBetween: 10,
        centeredSlides: false,
      },
    },
  });
  
/** pdp-thumb-slider **/
    var galleryThumbs = new Swiper(".gallery-thumbs-left", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 3,
      spaceBetween: 20,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: "vertical",  
      breakpoints: {
        992: {
          direction: 'vertical', 
        },
        768: {
          direction: 'horizontal', 
          slidesPerView: 3,
          spaceBetween: 15,
        },
        576: {
          direction: 'horizontal', 
          slidesPerView: 4,
        },
        320: {
          direction: 'horizontal', 
          slidesPerView: 3,
        },
      },
    });
    var galleryMain = new Swiper(".gallery-main-left", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumbs.slideTo(galleryMain.activeIndex);
    });
  
    galleryThumbs.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumbs.activeIndex);
    });
  /** blog page slider **/
  var swiper = new Swiper(".elegant-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
    },
  });
   /** product slider **/
   var swiper = new Swiper(".our-team-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /** counter js **/
  $('.counting').each(function() {
      var $this = $(this),
          countTo = $this.attr('data-count');
      
      $({ countNum: $this.text()}).animate({
        countNum: countTo
      },

      {

        duration: 3000,
        easing:'linear',
        step: function() {
          $this.text(Math.floor(this.countNum));
        },
        complete: function() {
          $this.text(this.countNum);
        }

      });  
    });

  /********* mobile stickybar ********/
  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      $(".mobile-stickybar").addClass('show');
    } else {
      $(".mobile-stickybar").removeClass('show');
    }
  });
function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
    if($('body').hasClass('mobile-open') ){
      $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
     }
  }

  
  if(jQuery(window).width() < 992) {
     if(!$('.mobile-lag').length > 0 ){
      const newDiv = document.createElement('ul');
      newDiv.className = 'mobile-lag d-flex align-items-center';
      $(newDiv).insertAfter('.menu-close-icon');
      $('.country-name, .languages').prependTo('.mobile-lag');
    }else{
       return false;
    }
  }
  else {
    $('.country-name, .languages').insertAfter('.search-header');
    $('.mobile-lag').remove();
  }
  
}
jQuery(document).ready(function() {
  responsiveMenu();
});
jQuery(window).resize(function() {
  responsiveMenu();
});
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' + '<span><span>%H</span><span class="dots"> : </span></span>' + '<span><span>%M</span><span class="dots"> : </span></span>' + '<span><span class="second">%S</span></span>'));
      });
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
     }
  });
}

// infinit scroll
function initializeAjaxinate(containerSelector) {
  var endlessScroll = new Ajaxinate({
    container: containerSelector,
    pagination: '#collection-Pagination',
    loadingText: '<img src="https://cdn.shopify.com/s/files/1/0751/3771/2446/files/813.gif?v=1692071901" class="infinity-loader">',
    callback: callbackInfiniteScroll
  });
}

function callbackInfiniteScroll() {
  countDownIni('.flip-countdown,.js-flip-countdown');

      jQuery('.product-grid-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-image-wrapper');
        jQuery(this).find('.product-card-image').insertAfter(prod_img);
          var prod_lbl = jQuery(this).find('.product-top-content');
        jQuery(this).find('.top-lable').prependTo(prod_lbl);
        var prod_count = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-image-bottom .simple-countdown').appendTo(prod_count);
        var prod_img = jQuery(this).find('.product-bottom-content');
        jQuery(this).find('.reviews-stars-wrap').prependTo(prod_img);
         var prod_img = jQuery(this).find('.reviews-stars-wrap');
        jQuery(this).find('.price').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.price');
        jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.wish-lbl-wrp');
        jQuery(this).find('.cart-variable').insertAfter(prod_img);
        var prod_desc = jQuery(this).find('.product-content .product-bottom-content');
        jQuery(this).find('.product-image-bottom .cart-btn-content').appendTo(prod_desc);
      });
}

document.addEventListener("DOMContentLoaded", function() {
  initializeAjaxinate('.flex-slider');

  const list_view = document.querySelector(".list-view");
  if(list_view){
      list_view.addEventListener('click', function(event) {
    if (event.target.classList.contains('product-grid-view')) {
      initializeAjaxinate('.product-grid-view');
    }
  });
  }
  
});